// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_MessageRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_MessageRow — one row of `franchisor_channel_messages`
 * (one row PER RECIPIENT per dispatch). `created_at` is ISO-8601 UTC — the
 * controller converts from GMT-3 storage before building this row.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_MessageRow {
id: number
franquia_id: number
trigger_key?: string
channel_id?: number
recipient?: string
recipient_sub?: string
template_id?: number
provider_message_id?: string
status?: string
detail?: string
created_at?: string
}

registerContract('FranchisorChannels_MessageRow', {
  id:                  { type: 'number',  required: true },
  franquia_id:         { type: 'number',  required: true },
  trigger_key:         { type: 'string',  required: false },
  channel_id:          { type: 'number',  required: false },
  recipient:           { type: 'string',  required: false },
  recipient_sub:       { type: 'string',  required: false },
  template_id:         { type: 'number',  required: false },
  provider_message_id: { type: 'string',  required: false },
  status:              { type: 'string',  required: false },
  detail:              { type: 'string',  required: false },
  created_at:          { type: 'string',  required: false },
})
